var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"wrap"},[_c('div',[_vm._v("404")]),_c('p',[_vm._v("页面错误，未找到该页面！")])])])}]

export { render, staticRenderFns }